// extracted by mini-css-extract-plugin
export var tosLink = "_bb-0";